import React from "react";
import { formatDateKorean } from "@semo/shared-utils";

interface QuoteHeaderProps {
  title?: string;
  date: string;
}

export function QuoteHeader({ title = "견 적 서", date }: QuoteHeaderProps) {
  const formattedDate = formatDateKorean(date);

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-4 sm:gap-0 mb-6 sm:mb-8 border-b border-gray-200 pb-4 sm:pb-6">
      <div>
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-[0.15em] sm:tracking-[0.2em] text-primary-text leading-tight">
          {title}
        </h1>
      </div>
      <div className="text-left sm:text-right">
        <div className="text-xs sm:text-sm md:text-sm text-gray-500">
          견적일: {formattedDate}
        </div>
      </div>
    </div>
  );
}
